import { useQuery } from '@tanstack/react-query';
import {
  fetchProductTraceByInternalOrderId,
  fetchProductTraceByPurchaseOrderId,
  fetchProductTraceBySalesOrderId,
} from '@/api/orders';

export const productTraceKeys = {
  all: ['productTrace'] as const,
  detail: (orderId: string) => [...productTraceKeys.all, orderId] as const,
  internalDetail: (orderId: string) =>
    [...productTraceKeys.all, 'internal', orderId] as const,
};

export function useProductTraceBySalesOrderId(soId: string) {
  return useQuery({
    queryKey: productTraceKeys.detail(soId),
    queryFn: () => fetchProductTraceBySalesOrderId(soId),
    enabled: !!soId,
    staleTime: 60_000,
  });
}

export function useProductTraceByPurchaseOrderId(poId: string) {
  return useQuery({
    queryKey: productTraceKeys.detail(poId),
    queryFn: () => fetchProductTraceByPurchaseOrderId(poId),
    enabled: !!poId,
    staleTime: 60_000,
  });
}

export function useProductTraceByInternalOrderId(ioId: string) {
  return useQuery({
    queryKey: productTraceKeys.internalDetail(ioId),
    queryFn: () => fetchProductTraceByInternalOrderId(ioId),
    enabled: !!ioId,
    staleTime: 60_000,
  });
}
